module.exports = __webpack_public_path__ + "img/EXALT_ELEVATED.7d5905e4.jpg";